import { IRegularWithdrawalPlan } from "src/app/models/withdrawals";

export interface IWithdrawalState {
    regularWithdrawals: IRegularWithdrawalPlan[];
    loading: boolean;
    createWithdrawalSuccess: boolean;
    createWithdrawalSuccessText: string;
    editRegularWithdrawalSuccess: boolean;
    editRegularWithdrawalSuccessText: string;
    stopRegularWithdrawalSuccess: boolean;
    stopRegularWithdrawalSuccessText: string;
}

export const initialWithdrawalState: IWithdrawalState = {
    regularWithdrawals: null,
    loading: false,
    createWithdrawalSuccess: false,
    createWithdrawalSuccessText: '',
    editRegularWithdrawalSuccess: false,
    editRegularWithdrawalSuccessText: '',
    stopRegularWithdrawalSuccess: false,
    stopRegularWithdrawalSuccessText: ''
};